@if (
	clipboardService.clients().length > 0 ||
	clipboardService.courses().length > 0 ||
	clipboardService.units().length > 0 ||
	clipboardService.lessons().length > 0 ||
	clipboardService.activities().length > 0 ||
	clipboardService.contents().length > 0
) {
	<nz-tabs>
		<nz-tab nzTitle="Clipboard">
			<div class="clipboard">
				@if (clipboardService.clients().length > 0) {
					<div class="clipboard-item">
						<span class="label">Clients</span>
						<span class="name">{{ clipboardService.clients().length }}</span>
						<div class="button-group">
							<button
								(click)="clipboardService.pasteClients()"
								nz-button
								nzType="primary"
								[disabled]="!clipboardService.canPasteClients()"
							>
								Paste
							</button>
							<button (click)="clipboardService.clearClients()" nz-button>Clear</button>
						</div>
					</div>
				}

				@if (clipboardService.courses().length > 0) {
					<div class="clipboard-item">
						<span class="label">Courses</span>
						<span class="name">{{ clipboardService.courses().length }}</span>
						<div class="button-group">
							<button
								(click)="clipboardService.pasteCourses()"
								nz-button
								nzType="primary"
								[disabled]="!clipboardService.canPasteCourses()"
							>
								Paste
							</button>
							<button (click)="clipboardService.clearCourses()" nz-button>Clear</button>
						</div>
					</div>
				}

				@if (clipboardService.units().length > 0) {
					<div class="clipboard-item">
						<span class="label">Units</span>
						<span class="name">{{ clipboardService.units().length }}</span>
						<div class="button-group">
							<button
								(click)="clipboardService.pasteUnits()"
								nz-button
								nzType="primary"
								[disabled]="!clipboardService.canPasteUnits()"
							>
								Paste
							</button>
							<button (click)="clipboardService.clearUnits()" nz-button>Clear</button>
						</div>
					</div>
				}

				@if (clipboardService.lessons().length > 0) {
					<div class="clipboard-item">
						<span class="label">Lessons</span>
						<span class="name">{{ clipboardService.lessons().length }}</span>
						<div class="button-group">
							<button
								(click)="clipboardService.pasteLessons()"
								nz-button
								nzType="primary"
								[disabled]="!clipboardService.canPasteLessons()"
							>
								Paste
							</button>
							<button (click)="clipboardService.clearLessons()" nz-button>Clear</button>
						</div>
					</div>
				}

				@if (clipboardService.activities().length > 0) {
					<div class="clipboard-item">
						<span class="label">Activities</span>
						<span class="name">{{ clipboardService.activities().length }}</span>
						<div class="button-group">
							<button
								(click)="clipboardService.pasteActivities()"
								nz-button
								nzType="primary"
								[disabled]="!clipboardService.canPasteActivities()"
							>
								Paste
							</button>
							<button (click)="clipboardService.clearActivities()" nz-button>Clear</button>
						</div>
					</div>
				}

				@if (clipboardService.contents().length > 0) {
					<div class="clipboard-item">
						<span class="label">Contents</span>
						<span class="name">{{ clipboardService.contents().length }}</span>
						<div class="button-group">
							<button
								(click)="clipboardService.pasteContents()"
								nz-button
								nzType="primary"
								[disabled]="!clipboardService.canPasteContents()"
							>
								Paste
							</button>
							<button (click)="clipboardService.clearContents()" nz-button>Clear</button>
						</div>
					</div>
				}
			</div>
		</nz-tab>
		<nz-tab nzTitle="Details">
			<nz-table nzNoResult=" ">
				<thead>
					<tr>
						<th>Model</th>
						<th>Name</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					@for (client of clipboardService.clients(); track $index) {
						<tr>
							<td>Client</td>
							<td>{{ client.active_text?.name }}</td>
							<td>
								<button (click)="clipboardService.clearClient(client.uuid)" nz-button>Clear</button>
							</td>
						</tr>
					}
					@for (course of clipboardService.courses(); track $index) {
						<tr>
							<td>Course</td>
							<td>{{ course.active_text?.name }}</td>
							<td>
								<button (click)="clipboardService.clearCourse(course.uuid)" nz-button>Clear</button>
							</td>
						</tr>
					}
					@for (unit of clipboardService.units(); track $index) {
						<tr>
							<td>Unit</td>
							<td>{{ unit.active_text?.name }}</td>
							<td>
								<button (click)="clipboardService.clearUnit(unit.uuid)" nz-button>Clear</button>
							</td>
						</tr>
					}
					@for (lesson of clipboardService.lessons(); track $index) {
						<tr>
							<td>Lesson</td>
							<td>{{ lesson.active_text?.name }}</td>
							<td>
								<button (click)="clipboardService.clearLesson(lesson.uuid)" nz-button>Clear</button>
							</td>
						</tr>
					}
					@for (activity of clipboardService.activities(); track $index) {
						<tr>
							<td>Activity</td>
							<td>{{ activity.active_text?.name }}</td>
							<td>
								<button (click)="clipboardService.clearActivity(activity.uuid)" nz-button>Clear</button>
							</td>
						</tr>
					}
					@for (content of clipboardService.contents(); track $index) {
						<tr>
							<td>Content</td>
							<td>{{ content.active_text?.name }}</td>
							<td>
								<button (click)="clipboardService.clearContent(content.uuid)" nz-button>Clear</button>
							</td>
						</tr>
					}
				</tbody>
			</nz-table>
		</nz-tab>
	</nz-tabs>
}
